import AOS from "aos";

import {
  initVideo,
  accordion,
  initVideoFooter,
  initTopbar,
  initInstagram,
  initGalleryPhotoSwipe,
  showHideElementsFilter,
  initDatePicker,
  initSearchbarAccordion,
  initVoucherConfigurator,
  checkIfGiftFormIsValidated,
  initSmoothScroll,
} from "./functions";
import { initMap } from "./map";

$(document).ready(function () {
  initTopbar();
  initSmoothScroll();
  initInstagram();
  let videoMain = document.getElementById("video-main");
  let footerVideo = document.getElementById("footer-video");
  let sliderVideo = document.getElementById("video-slider");
  let sliderVideoProduct = document.getElementById("video-slider-product");
  let sliderVideoFlowers = document.getElementById("video-slider-flowers");

  if (footerVideo) initVideoFooter(footerVideo, false);
  if (videoMain) initVideoFooter(videoMain, false);
  if (sliderVideo) initVideoFooter(sliderVideo, true);
  if (sliderVideoProduct) initVideoFooter(sliderVideoProduct, "product");
  if (sliderVideoFlowers) initVideoFooter(sliderVideoFlowers, "flowers");

  if ($(".reservation").length) {
    initDatePicker();
    initVoucherConfigurator();
    window.checkIfGiftFormIsValidated = checkIfGiftFormIsValidated;
  }

  if ($("#find-clinic-map").length) {
    initMap("find-clinic-map", true);
  }

  if ($("#find-clinic-map-cities").length) {
    initMap("find-clinic-map-cities", true, false);
  }
  if ($("#contact-map").length) initMap("contact-map", false, false, 6, false);
  if ($(".js-accordion").length) {
    accordion.init();
    initSearchbarAccordion();
  }
  if ($(".gallery").length) initGalleryPhotoSwipe();
  if ($(".video-wrapper").length) initVideo();

  // Contact form

  function contactFromSucces(token) {
    document.getElementById("w0").submit();
  }
  window.contactFromSucces = contactFromSucces;

  // grecaptcha.ready(function () {
  //   $("#formularz-kontaktowy #sendform").attr("disabled", true);
  // });

  // $("#terms").click(function () {
  //   $("#sendform").attr("disabled", !this.checked);
  // });
});

// ANIMATIONS
AOS.init({
  duration: 1000,
  startEvent: "load",
  easing: "ease-in-out-cubic",
});

// Newsletter check
$("#checkbox-rodo").click(function (e) {
  e.preventDefault();
  if ($(this).prop("checked") === true) {
    $(".rodo-popup--newsletter").addClass("active");
  }
});

$(".promo-popup__close").click(function () {
  $(".promo-popup").removeClass("active");
});

$("#accept-rodo").click(function (e) {
  e.preventDefault();
  $(".btn__newsletter").prop("disabled", false);
  $("#checkbox-rodo").prop("checked", true);
  $(".rodo-popup--newsletter").removeClass("active");
});

function validateEmail($email) {
  var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
  return emailReg.test($email);
}

$("#newsletter-form").submit(function (event) {
  event.preventDefault();
  if (
    !validateEmail($("input#newsletter").val()) ||
    $("input#newsletter").val().length === 0
  ) {
    $("input#newsletter").addClass("input__error").effect(
      "shake",
      {
        times: 4,
        distance: 5,
      },
      100
    );
  } else {
    $.ajax({
      url: $(this).attr("action"),
      type: "POST",
      data: $(this).serialize(),
      success: function (response) {
        //$( "#newsletter-form .input" ).text(response);
        $("#newsletter-form .input").text(
          "Zapisano do newslettera. Dziękujemy"
        );
      },
    });
  }
});

//EVENT LISTENERS

$("#checkbox-regulamin").change(function () {
  $("#checkbox-regulamin-error").remove();
});

$('input[name="delivery"]').change(function () {
  $("#delivery-error").remove();

  if ($(this).val() === "personal_pickup") {
    $("input[name='FormGift[city]']").rules("add", {
      required: false,
    });
    $("input[name='FormGift[address]']").rules("add", {
      required: false,
    });
    $("input[name='FormGift[postal_code]']").rules("add", {
      required: false,
    });

    $('input[value="cash_on_delivery"]')
      .prop("disabled", false)
      .prop("checked", true);
    //	$('input[value="payu"]').prop("disabled", true).prop("checked", false);
  } else {
    $("input[name='FormGift[city]']").rules("add", {
      required: true,
    });
    $("input[name='FormGift[address]']").rules("add", {
      required: true,
    });
    $("input[name='FormGift[postal_code]']").rules("add", {
      required: true,
    });

    $('input[value="cash_on_delivery"]')
      .prop("disabled", true)
      .prop("checked", false);
    $('input[value="payu"]').prop("disabled", false).prop("checked", true);
  }
});

$("#category-filter li").click(function () {
  var filter = $(this).data("filter");
  showHideElementsFilter(filter);
});

if ($(".series__with-product-descirption").length) {
  $(".product").click(function (event) {
    if (event.target.className != "additional-info open") {
      $([document.documentElement, document.body])
        .stop()
        .animate(
          {
            scrollTop: $(this).find(".additional-info").offset().top - 80,
          },
          1000
        );

      $(".additional-info").removeClass("open");
      $(this).find(".additional-info").addClass("open");
    }
  });
  $(".icon--close").click(function (event) {
    event.stopPropagation();
    $(this).parent().removeClass("open");
    $([document.documentElement, document.body])
      .stop()
      .animate(
        {
          scrollTop: $(this).parent().parent().offset().top - 80,
        },
        1000
      );
  });
}

window.onload = (event) => {
  // const app = document.getElementById("booster-app");
  // const shield = app.querySelector(".booster-app__wrapper");
  // const msg = app.querySelector(".booster-app__messages-item");
  // const close = app.querySelector(".booster-app__close");

  // setTimeout(function () {
  //   app.style.opacity = "1";
  // }, 50);

  // setTimeout(function () {
  //   msg.classList.remove("booster-app__messages-item--fade-out");
  // }, 500);

  // // close
  // close.addEventListener("click", (e) => {
  //   shield.classList.add("booster-app__wrapper--minimized");
  //   close.classList.add("booster-app__hide");
  //   msg.classList.add("booster-app__messages-item--fade-out");
  // });

  // app
  //   .querySelector(".booster-app__icon-wrapper")
  //   .addEventListener("click", () => {
  //     shield.classList.remove("booster-app__wrapper--minimized");
  //     close.classList.remove("booster-app__hide");
  //     msg.classList.remove("booster-app__messages-item--fade-out");
  //   });

  function cookies() {
    var cookies = $(".cookies");
    var btns = $(".cookies__close, .cookies__close-btn");

    btns.on("click", function () {
      cookies.fadeOut();
      $.cookie("cookie", 1, {
        expires: 365,
      });
    });

    if (!$.cookie("cookie")) {
      cookies.removeClass("hidden");
    }
  }
  cookies();
};
